import React from "react";
import PropTypes from "prop-types";

const PrintDocumentHeader = (props) => {
  const {View, Text, Image} = window.ReactPdfRenderer;

  const {styles, jobId, fabricatorData, printLogo, messages} = props;

  const date = new Date();

  const logoView = printLogo ? (
    <View style={fabricatorData.isAmericanStandard ? [styles.headerLogo, styles.headerLogoAS] : styles.headerLogo}>
      <Image style={styles.headerLogoImage} source={{ uri: printLogo, method: "GET", headers: { "Cache-Control": "no-cache" } }} />
    </View>
  ) : null;

  const jobInfoView = (
    <View style={styles.headerInfo}>
      {document.kvConfig.jobId || jobId ? (
        <View style={styles.headerText}>
          <Text style={styles.headerTextBold}>{messages["receipt.header.quoteNumber"]}</Text>
          <Text style={styles.headerTextValue}>{document.kvConfig.jobId || jobId}</Text>
        </View>
      ) : null}
      <View style={styles.headerText}>
        <Text style={styles.headerTextBold}>{messages["receipt.header.date"]}</Text>
        <Text style={styles.headerTextValue}>{date.toLocaleDateString().replace(/\//gi, "-")}</Text>
      </View>
      <View style={styles.headerText}>
        <Text style={styles.headerTextBold}>{messages["receipt.header.time"]}</Text>
        <Text style={styles.headerTextValue}>{date.toLocaleTimeString()}</Text>
      </View>
    </View>
  )

  if (fabricatorData.isAmericanStandard) {
    return (
      <View style={styles.specSheet} fixed={true}>
        <View style={styles.headerTextASSheet}>
          <Text style={styles.headerTextBold}>Specification Sheet</Text>
        </View>
        {logoView}
        <View style={styles.headerTextASInfo}>{jobInfoView}</View>
      </View>
    )
  }

  return (
    <View style={styles.header}>
      <View style={styles.headerTextASSheet}/>
      {logoView}
      <View style={styles.headerTextASInfo}>{jobInfoView}</View>
    </View>
  )
};

PrintDocumentHeader.propTypes = {
  fabricatorData: PropTypes.object,
  jobId: PropTypes.number,
  styles: PropTypes.object.isRequired,
  printLogo: PropTypes.string,
};

export default PrintDocumentHeader
